// extracted by mini-css-extract-plugin
module.exports = {"educatorID":"dashboard_educatorID__1VJCP"};